import { defineComponent as _defineComponent } from 'vue'
import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

import {onMounted} from 'vue';
  import Client from "@/utils/client";

  
export default /*#__PURE__*/_defineComponent({
  __name: 'Test',
  setup(__props) {

  let crossStorage: Client;
  onMounted(() => {
    // TODO 修改client链接
    crossStorage = new Client('http://localhost:3000/hub');
    console.log("12123123")

  });

  const getSharedMsg = () => {
    crossStorage.getItem('refreshToken', (result: string) => {
      console.log('refreshToken: ', result)
    });
    crossStorage.getItem('accessToken', (result: string) => {
      console.log('accessToken: ', result)
    })
  };

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", null, [
    _createElementVNode("div", { onClick: getSharedMsg }, "获取共享localstarage")
  ]))
}
}

})